import { render } from "./MessageBox.vue?vue&type=template&id=78b890fb&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=78b890fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b890fb"]])

export default __exports__